import type { CuratedItem } from "./config";

export const curatedList: CuratedItem[] = [
  {
    id: "music1",
    title: { en: "Dark Side of the Moon", tr: "Dark Side of the Moon" },
    subtitle: { en: "Pink Floyd (Album)", tr: "Pink Floyd (Albüm)" },
    category: "music"
  },
  {
    id: "music2",
    title: { en: "Kind of Blue", tr: "Kind of Blue" },
    subtitle: { en: "Miles Davis (Album)", tr: "Miles Davis (Albüm)" },
    category: "music"
  },
  {
    id: "book1",
    title: { en: "Gödel, Escher, Bach", tr: "Gödel, Escher, Bach" },
    subtitle: { en: "Douglas Hofstadter", tr: "Douglas Hofstadter" },
    category: "books"
  },
  {
    id: "book2",
    title: { en: "The Myth of Sisyphus", tr: "Sisifos Söyleni" },
    subtitle: { en: "Albert Camus", tr: "Albert Camus" },
    category: "books"
  },
  {
    id: "film1",
    title: { en: "Interstellar", tr: "Yıldızlararası" },
    subtitle: { en: "Christopher Nolan", tr: "Christopher Nolan" },
    category: "films"
  },
  {
    id: "film2",
    title: { en: "Persona", tr: "Persona" },
    subtitle: { en: "Ingmar Bergman", tr: "Ingmar Bergman" },
    category: "films"
  }
];
